export default "__VITE_ASSET__DxuDPjrv__"